import { BlueprintUnassignedWarningIgnoreButtonWrapper } from "@src/components/molecules/blueprint-unassigned-warning-ignore-button-wrapper/blueprint-unassigned-warning-ignore-button-wrapper";
import React from "react";
import { renderDataAcquisitionTypeWrapper } from "./render-data-acquisition-type-wrapper";

export const manageUnassignedNodeViewInBlueprintMode = (child, type) => {
  if (type !== "machine") return;
  if (!child.unassigned) {
    return <>{renderDataAcquisitionTypeWrapper(child, type)}</>;
  } else {
    return <BlueprintUnassignedWarningIgnoreButtonWrapper />;
  }
};
